import { IAddressPositionEntry } from "Redux/Query";

export const SET_USER_DATA = 'SET_USER_DATA';

type TUserData = IAddressPositionEntry & { name: string }

export const setUserData = (payload: TUserData) => ({
    type: SET_USER_DATA,
    payload
})